<app-page-title title="Regras por membro"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<div class="search-container">
  <input class="search-input" placeholder="Buscar por nome..." [(ngModel)]="searchValue" autocomplete="off" #input />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" (click)="search(input.value)" />
  </div>
</div>
<br />
<app-no-data *ngIf="members.length == 0" title="Sem dados" subtitle=" Nenhum membro encontrado"></app-no-data>

<div class="header-back">
  <button class="back-btn" [routerLink]="['/permissoes']">Voltar para Permissões</button>
</div>

<div>
  <div class="members-list" (scroll)="onScroll($event)">
    <div *ngFor="let member of members">
      <app-member-card [member]="member" [showActions]="false" [allowExpand]="true"></app-member-card>
    </div>

    <div class="load-more" *ngIf="paginate.page < paginate.lastPage"></div>
  </div>
</div>
